import * as React from "react";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { PageLive } from "../page/PageLive";
import { PageNotFound } from "../redirects/PageNotFound";
import { useCurrentInstanceData } from "../../contexts/InstanceDataContext";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";

const SharedPageLiveRoute = () => {
    const { pageId } = useRoutedParamsWithContext();
    const { instance } = useCurrentInstanceData();

    if (!instance) {
        return null;
    }

    if (instance.preferences?.features?.sharedPageLibrariesEnabled === false) {
        return <PageNotFound />;
    }

    return <PageLive id={pageId!} />;
};

export const sharedPageRoutes = [
    {
        path: "/shared-page/:instanceId/:pageId/live",
        content: <SharedPageLiveRoute />,
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="LivePage" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="LivePage" entityId={instanceId!} />;
        }
    }
];
